<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"><span class="txit">To every English teacher and librarian<br/>who gave me a passion for books, thank you.</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0eb00f74